import React from 'react';
import { Content, EmailText, PageContainer } from './SupportPage.styles';
import { Header } from '../../components';
import { Text14Regular } from '../../components/utils/Text/Text.styles';

const SupportPage = () => {
  return (
    <PageContainer>
      <Header title="Support" />
      <Content>
        <Text14Regular>To report bugs, get support for as questions, please reach out to us at:</Text14Regular>
        <EmailText>support@onlychats.com 💌</EmailText>
      </Content>
    </PageContainer>
  );
};

export default SupportPage;
